/*
 * reusable close button element that needs a handler via `opts`
 */
import './entypo/entypo-svg.tag'

riot.tag2('close-button', '<button class="btn button button--close"> <entypo-svg symbol="close"></entypo-svg> </button>', '', '', function(opts) {
});



// WEBPACK FOOTER //
// ./src/components/close-button.tag